<template>
  <div
    class="header-wrapper row m-0"
    style="background: white; min-height: 86px; z-index: 100"
  >
    <SearchBar />
    <Logo />

    <div class="left-header col-xxl-5 col-xl-6 col-lg-5 col-md-4 col-sm-3 p-0">
      <!-- <div class="notification-slider"> -->
      <!-- <span style="font-size: 20px; font-weight: 700">{{this.$store.state.judulHalaman}}</span> -->

      <div
        id="breadcrumb_text"
        style="font-family: 'Inter'"
        class="d-flex align-items-center"
      >
        <template v-for="(item, index) in breadcrumb" :key="index">
          <div
            v-if="breadcrumb.length >= 4 && index + 1 == 1"
            class="d-flex align-items-center"
          >
            <div
              style="font-family: 'Inter'; font-weight: bolder"
              class="breadcrumb_link"
              @click="toPath(item.name)"
            >
              {{ item.name }}
            </div>
            <div class="m-l-10 m-r-20">
              <img src="@/assets/images/a/arrow.svg" class="breadcrumb_arrow" />
            </div>
          </div>

          <div
            v-if="breadcrumb.length >= 4 && index + 1 == 2"
            class="d-flex align-items-center"
          >
            <div class="dropdown">
              <div
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                class="breadcrumb_link"
              >
                ...
              </div>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <template v-for="(i, idx) in breadcrumb" :key="index">
                  <li>
                    <a
                      v-if="idx != 0 && idx + 1 != breadcrumb.length"
                      class="dropdown-item breadcrumb_item"
                      href="#"
                      >{{ i.name }}</a
                    >
                  </li>
                </template>
              </ul>
            </div>
            <div class="m-l-10 m-r-20">
              <img src="@/assets/images/a/arrow.svg" class="breadcrumb_arrow" />
            </div>
          </div>

          <div
            v-if="breadcrumb.length < 4 && index + 1 !== breadcrumb.length"
            class="d-flex align-items-center"
            id="breadcrumb_text"
          >
            <div
              style="font-family: 'Inter'; font-weight: bold"
              id="breadcrumb_link"
              class="breadcrumb_link"
              @click="toPath(item.name)"
            >
              {{ item.name }}
            </div>
            <div class="m-l-10 m-r-20">
              <img src="@/assets/images/a/arrow.svg" class="breadcrumb_arrow" />
            </div>
          </div>
          <div
            style="font-family: 'Inter'; font-weight: bold"
            id="breadcrumb_text"
            v-if="index + 1 === breadcrumb.length"
            class="breadcrumb_text mt-1"
          >
            {{ item.name }}
          </div>
        </template>
      </div>

      <!-- <swiper
        :slidesPerView="1"
        :autoplay="{
          delay: 2500,
          disableOnInteraction: false,
        }"
        :modules="modules"
        class="notification-slider"
        direction="vertical"
      >
        <swiper-slide class="h-100">
          <div class="d-flex h-100">
            <h6 class="mb-0 f-w-400">
              <span class="font-dark font-bold">{{ nameHeader }} </span>
            </h6>
          </div>
        </swiper-slide>
      </swiper> -->

      <!-- </div> -->
    </div>
    <div
      class="nav-right col-xxl-7 col-xl-6 col-md-7 col-8 pull-right right-header p-0 ms-auto"
    >
      <ul class="nav-menus mobile-header-select">
        <!-- <li>
          <span class="header-search"
            ><svg @click="search_open()">
              <use href="@/assets/svg/icon-sprite.svg#search"></use>
            </svg>
          </span>
        </li> -->

        <!-- <li class="onhover-dropdown">
          <svg @click="bookmark_open()">
            <use href="@/assets/svg/icon-sprite.svg#star"></use>
          </svg>

          <Bookmark v-bind:activeclass="bookmark" />
        </li>
        <li>
          <Mode />
        </li>
        <Cart />
        <Notifications />
        -->
        <Download class="m-r-20" />
        <ManualBook v-if="!isGuest" class="m-r-20" />
        <!-- <Message /> -->
        <Profile />
      </ul>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Bookmark from "../bookmark";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay } from "swiper";
import "swiper/css";
import Notifications from "./notifications.vue";
import Mode from "./mode";
import Cart from "./cart";
import Profile from "./profile";
import Logo from "./logo.vue";
import SearchBar from "./search";
import Message from "./message";
import Download from "./download";
import financePdf from "../../pages/master-pdf/master-pdf.vue";
import ManualBook from "./manualBook.vue";
import { checkIsGuest } from "@/utils/helper";

export default {
  //   name: 'Search',
  components: {
    Download,
    Message,
    Bookmark,
    Notifications,
    Mode,
    Cart,
    Profile,
    Logo,
    Swiper,
    SwiperSlide,
    financePdf,
    SearchBar,
    ManualBook,
  },
  data() {
    return {
      bookmark: false,
      nameHeader: "",
      isMobile: false,
    };
  },
  computed: {
    ...mapState({
      menuItems: (state) => state.menu.searchData,
      megamenuItems: (state) => state.menu.megamenu,
      searchOpen: (state) => state.menu.searchOpen,
    }),

    breadcrumb() {
      let data = this.$route.matched;
      let path = window.location.pathname;
      let datas = [];
      for (let i = 1; i < data.length; i++) {
        const e = data[i];
        if (e.name !== undefined) {
          if (this.$store.state.judulHalaman !== "") {
            datas.push({
              name: e.name,
              path: e.path,
            });
            datas.push({
              name: this.$store.state.judulHalaman,
              path: "/" + this.$store.state.judulHalaman,
            });
          } else {
            datas.push({
              name: e.name,
              path: e.path,
            });
          }
        }
      }
      return datas;
    },
    isGuest() {
      return checkIsGuest();
    },
  },
  created() {
    this.getResolution();
    this.headerName();
  },
  methods: {
    getResolution() {
      this.isMobile = window.screen.width > 760 ? true : false;
    },
    pdf() {
      this.$refs.pdf.generateReport();
    },
    headerName(x) {
      const url = x === undefined ? window.location.pathname : x;
      if (url === "/") {
        this.nameHeader = "PLN Management contract";
      } else if (url.includes("finance")) {
        this.nameHeader = "FINANCE";
      }
    },
    search_open() {
      this.$store.state.menu.searchOpen = true;
    },
    bookmark_open() {
      this.bookmark = !this.bookmark;
    },

    toPath(name) {
      if (name === "moonshot") {
        this.breadcrumb.pop();
        location.reload();
        this.$store.commit("updatePageMoonshot", true);
      } else {
        this.$router.push({ name: name });
      }
    },
  },
  setup() {
    return {
      modules: [Autoplay],
    };
  },
};
</script>
<style scoped>
.font-bold {
  font-weight: bold;
  font-size: larger;
}
</style>

<style scoped lang="scss"></style>
